<template>
  <div class="bg-white py-6 md:pt-8 sticky z-30 top-10 md:top-0 -mx-[4vw] px-[4vw] overflow-x-auto no-scrollbar">
    <div class="flex gap-4 md:gap-6 text-sm md:text-base whitespace-nowrap underline text-ocean decoration-sky">
      <button @click.prevent="scrollToSection('hero')">
        {{ $t('restaurant.navigation.description') }}
      </button>
      <button @click.prevent="scrollToSection($t('restaurant.navigation.goodToKnow'), -110)">
        {{ $t('restaurant.navigation.goodToKnow') }}
      </button>
      <button @click.prevent="scrollToSection($t('restaurant.navigation.menu'), -110)" v-if="restaurant.menus?.length > 1">
        {{ $t('restaurant.navigation.menu') }}
      </button>
      <button @click.prevent="scrollToSection($t('restaurant.navigation.images'), -110)" v-if="restaurant.images?.length > 1">
        {{ $t('restaurant.navigation.images') }}
      </button>
      <!-- <button @click.prevent="scrollToSection($t('restaurant.navigation.booking'), -110)" v-if="restaurant.bookable">
        {{ $t('restaurant.navigation.booking') }}
      </button> -->
      <button @click.prevent="scrollToSection($t('restaurant.navigation.openingHours'), -110)">
        {{ $t('restaurant.navigation.openingHours') }}
      </button>
      <button @click.prevent="scrollToSection($t('restaurant.navigation.contact'), -110)">
        {{ $t('restaurant.navigation.contact') }}
      </button>
      <button @click.prevent="scrollToSection($t('restaurant.navigation.map'), -110)">
        {{ $t('restaurant.navigation.map') }}
      </button>
      <div class="w-4">&nbsp;</div>
    </div>
  </div>
</template>

<script setup>
const route = useRoute()

const props = defineProps({
  restaurant: {
    type: Object,
    default: () => {}
  }
})
</script>